'use strict';

wbApp.controller('OnlineMeetingsCtrl', ['$scope', '$modal', '$translate', 'onlineMeetingsSvc', 'tenantInfo', 'messageBoxSvc', 'securitySvc',
function ($scope, $modal, $translate, onlineMeetingsSvc, tenantInfo, messageBoxSvc, securitySvc) {

    $scope.fromDate = moment().subtract(5, 'day').startOf('day');
    $scope.toDate = moment().add(1, 'day').startOf('day');
    $scope.onlineMeetings = [];

    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    $scope.onDataRangeChanged = function () {
        refreshData();
    }

    function refreshData()
    {
        $scope.onlineMeetings = onlineMeetingsSvc.getInfoByDateRange($scope.fromDate, $scope.toDate);
    }

    refreshData();

    $scope.gridSettings = {
        name: 'onlineMeetings',
        keyExpr: 'id',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            {
                dataField: 'scheduledStartTime',
                caption: $translate.instant('TXT_MENU_SCHEDULE'),
                dataType: 'date',
                format: { type: 'shortDateShortTime' },
                width: '120px',
                sortOrder: 'desc'
            },
            { dataField: 'employeeFullName', caption: $translate.instant('TXT_LBL_EMPLOYEE'), dataType: 'string', width: '160px' },
            { dataField: 'topic', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
            { dataField: 'hasRecordings', caption: $translate.instant('TXT_LBL_RECORDINGS'), dataType: 'boolean', width: '90px' },
            { dataField: 'lengthInMinutes', caption: $translate.instant('TXT_LBL_LESSON_LENGTH'), dataType: 'number', width: '90px' },
            {
                dataField: 'status',
                caption: $translate.instant("TXT_LBL_STATE"),
                dataType: 'number',
                width: '140px',
                calculateCellValue: function (rowData) {
                    switch (rowData.status)
                    {
                        case 0:
                            return $translate.instant('TXT_ONLINE_MEETING_STATE_NOT_STARTED');
                        case 1:
                            return $translate.instant('TXT_ONLINE_MEETING_STATE_IN_PROGRESS');
                        case 2:
                            return $translate.instant('TXT_ONLINE_MEETING_STATE_FINISHED');
                    }
                    return $translate.instant('TXT_ONLINE_MEETING_STATE_NOT_STARTED');
                },
                width: '110px'
            },
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.isDeleted) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_DIRECT_JOIN_LINK'),
            isVisible: function (data) { return securitySvc.isInRole('OnlineLessons'); },
            callback: function (data) { onShowDirectJoinLink(data.joinUrl); }
        }]
    }

    $scope.onRowSelected = function (data) {        
        $scope.$broadcast('selectedOnlineMeetingChanged', { meeting: data });
    }

    function onShowDirectJoinLink(joinUrl) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_DIRECT_JOIN_LINK',
            message: '<a href="{0}" target="_blank">{0}</a>'.f(joinUrl),
            buttons: [{
                text: 'TXT_BTN_OK'
            }]
        });
    }

    $scope.tabs = [
    {
        title: 'TXT_LBL_RECORDINGS',
        template: "courses/online-meetings/online-meetings-tabs/recordings.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });
   



}]);
